<script setup lang="ts">
    import { ref, computed, onMounted } from 'vue';

    const isOpen = ref(true);
    const windowWidth = ref(window.innerWidth);
    const isMobile = computed(() => windowWidth.value < 768);

    const toggleSidebar = () => {
        console.log(window.location.pathname);
        isOpen.value = !isOpen.value;
    };
    onMounted(() => {
        window.addEventListener('resize', () => {
            windowWidth.value = window.innerWidth;
            if (isMobile.value) {
                isOpen.value = false;
            }
        });
    });
</script>

<template>
    <div class="flex h-screen w-full">
        <Sidebar v-if="!isMobile" :isOpen="isOpen" @toggle="toggleSidebar" />
        <div class="flex-1 flex flex-col h-full">
            <!-- head navbar -->
            <HeadNav />

            <!-- Main Content Area -->
            <main
                v-if="!isMobile"
                class="flex-1 transition-all duration-200 pt-[86px] h-full"
                :style="{
                    marginLeft: isOpen ? '250px' : '80px'
                }"
            >
                <!-- Container dengan max-width dan center alignment -->
                <div class="w-full max-w-[1990px] mx-auto px-6 py-2.5">
                    <RouterView />
                </div>
            </main>

            <!-- Mobile Content Area -->
            <main v-else class="flex-1 pt-[86px] pb-[70px]">
                <div class="px-3">
                    <RouterView />
                </div>
            </main>

            <!-- Mobile Bottom Navigation -->
            <MobileBottomNav />
        </div>
    </div>
</template>
